/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDaysPreviewDto,
  FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto,
  FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceListDto,
  FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceSubstitutionResult,
  FacilityFlowCoreModulesPlanningDtosAbsencesApproveAbsenceRequest,
  FacilityFlowCoreModulesPlanningDtosAbsencesApproveAbsenceResult,
  FacilityFlowCoreModulesPlanningDtosAbsencesAssignAbsenceSubstituteRequest,
  FacilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest,
  FacilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest,
  GetApiV1AbsencesParams,
  GetApiV1AbsencesWorkingDaysParams,
  PostApiV1AbsencesIdCertificateBody
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAbsences = () => {
/**
 * @summary Get all absences with optional filters
 */
const getApiV1Absences = (
    params?: GetApiV1AbsencesParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceListDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceListDto[]>(
      {url: `/api/v1/absences`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new absence
 */
const postApiV1Absences = (
    facilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest: FacilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>(
      {url: `/api/v1/absences`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsencesCreateAbsenceRequest
    },
      options);
    }
  /**
 * @summary Chargeable working days an absence of the employee over this period would cost — by the
employee's work schedule model, without public holidays. Preview for the request form;
the same rule is applied when the absence is saved.
 */
const getApiV1AbsencesWorkingDays = (
    params?: GetApiV1AbsencesWorkingDaysParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDaysPreviewDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDaysPreviewDto>(
      {url: `/api/v1/absences/working-days`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Get a specific absence by ID
 */
const getApiV1AbsencesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>(
      {url: `/api/v1/absences/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing absence
 */
const putApiV1AbsencesId = (
    id: string,
    facilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest: FacilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>(
      {url: `/api/v1/absences/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsencesUpdateAbsenceRequest
    },
      options);
    }
  /**
 * @summary Delete an absence
 */
const deleteApiV1AbsencesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/absences/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Approve or reject an absence (Admin/Dispatcher only).
When approved: planned work (PlanEntries) in the period is marked as conflict; response includes
affectedPlanEntryIds and affectedPlanningEntryIds so the FE can show "must be reassigned" and drive reassignment.
 */
const postApiV1AbsencesIdApprove = (
    id: string,
    facilityFlowCoreModulesPlanningDtosAbsencesApproveAbsenceRequest: FacilityFlowCoreModulesPlanningDtosAbsencesApproveAbsenceRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesApproveAbsenceResult>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesApproveAbsenceResult>(
      {url: `/api/v1/absences/${id}/approve`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsencesApproveAbsenceRequest
    },
      options);
    }
  /**
 * @summary Assign a substitute to an already approved absence, handing the assignments in the
period over to them. Partial by design: whatever the substitute can take over moves,
the rest stays with the absent employee and is listed in the response. Call again to
pick up what is still open (ADR-0016).
 */
const postApiV1AbsencesIdSubstitute = (
    id: string,
    facilityFlowCoreModulesPlanningDtosAbsencesAssignAbsenceSubstituteRequest: FacilityFlowCoreModulesPlanningDtosAbsencesAssignAbsenceSubstituteRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceSubstitutionResult>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceSubstitutionResult>(
      {url: `/api/v1/absences/${id}/substitute`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosAbsencesAssignAbsenceSubstituteRequest
    },
      options);
    }
  /**
 * @summary File a doctor's certificate on behalf of an employee — the case where the note is
handed in on paper at the office. A repeated upload replaces the stored file.
Employees use POST /me/absences/{absenceId}/certificate for their own absences.
 */
const postApiV1AbsencesIdCertificate = (
    id: string,
    postApiV1AbsencesIdCertificateBody: PostApiV1AbsencesIdCertificateBody,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>>,) => {const formData = new FormData();
if(postApiV1AbsencesIdCertificateBody.file !== undefined) {
 formData.append(`file`, postApiV1AbsencesIdCertificateBody.file)
 }

      return customInstance<FacilityFlowCoreModulesPlanningDtosAbsencesAbsenceDto>(
      {url: `/api/v1/absences/${id}/certificate`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  return {getApiV1Absences,postApiV1Absences,getApiV1AbsencesWorkingDays,getApiV1AbsencesId,putApiV1AbsencesId,deleteApiV1AbsencesId,postApiV1AbsencesIdApprove,postApiV1AbsencesIdSubstitute,postApiV1AbsencesIdCertificate}};
export type GetApiV1AbsencesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['getApiV1Absences']>>>
export type PostApiV1AbsencesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['postApiV1Absences']>>>
export type GetApiV1AbsencesWorkingDaysResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['getApiV1AbsencesWorkingDays']>>>
export type GetApiV1AbsencesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['getApiV1AbsencesId']>>>
export type PutApiV1AbsencesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['putApiV1AbsencesId']>>>
export type DeleteApiV1AbsencesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['deleteApiV1AbsencesId']>>>
export type PostApiV1AbsencesIdApproveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['postApiV1AbsencesIdApprove']>>>
export type PostApiV1AbsencesIdSubstituteResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['postApiV1AbsencesIdSubstitute']>>>
export type PostApiV1AbsencesIdCertificateResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAbsences>['postApiV1AbsencesIdCertificate']>>>
